export const tvSeries = [
  {
    id: 'tv-1',
    title: '雾港档案',
    genre: '刑侦 / 悬疑',
    episodes: 32,
    status: '已完结',
    highlight: '以港口旧案为线索，单元与主线交织，真相层层剥开。',
  },
  {
    id: 'tv-2',
    title: '千帆过境',
    genre: '年代 / 励志',
    episodes: 45,
    status: '已完结',
    highlight: '一群年轻人的十年打拼，把小城故事讲出时代的重量。',
  },
  {
    id: 'tv-3',
    title: '月落长安',
    genre: '古装 / 言情',
    episodes: 52,
    status: '更新中',
    highlight: '服化道考究，感情线克制含蓄，群像戏尤其出彩。',
  },
  {
    id: 'tv-4',
    title: '代码之城',
    genre: '科技 / 都市',
    episodes: 26,
    status: '已完结',
    highlight: '聚焦程序员生态，专业细节扎实，笑点与燃点并存。',
  },
  {
    id: 'tv-5',
    title: '山那边的信',
    genre: '乡村 / 治愈',
    episodes: 24,
    status: '已完结',
    highlight: '返乡支教的日常流，节奏舒缓，适合睡前放松看。',
  },
  {
    id: 'tv-6',
    title: '第七码头',
    genre: '谍战 / 年代',
    episodes: 38,
    status: '更新中',
    highlight: '多线索并行，人物身份反转频繁，悬念一直吊到最后。',
  },
  {
    id: 'tv-7',
    title: '合租时代',
    genre: '都市 / 喜剧',
    episodes: 20,
    status: '已完结',
    highlight: '四位合租青年的日常群像，轻松下饭，一集一个笑点。',
  },
  {
    id: 'tv-8',
    title: '冰海回声',
    genre: '冒险 / 剧情',
    episodes: 30,
    status: '已完结',
    highlight: '极地科考题材，实景拍摄质感强，克服困难的群像很动人。',
  },
];